import * as yup from 'yup';

import { EmailSchema } from 'common/validation-schemas/Common.schema';
import { PasswordSchema } from './password.schema';

export const SignupSchema = yup.object({
  email: EmailSchema,
  password: PasswordSchema,
});
